import { render, staticRenderFns } from "./arvore.vue?vue&type=template&id=47b8d662&scoped=true"
import script from "./arvore.vue?vue&type=script&lang=js"
export * from "./arvore.vue?vue&type=script&lang=js"
import style0 from "./arvore.vue?vue&type=style&index=0&id=47b8d662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b8d662",
  null
  
)

export default component.exports